import { apiFetch } from "@/auth/apiClient";

export type AdminUserRow = {
  id: number;
  email: string;
  role?: "STUDENT" | "TEACHER" | "SYSTEM_ADMIN";
  userType?: string;
  createdAt?: string;
  profile?: {
    firstName?: string | null;
    lastName?: string | null;
  } | null;
};

export type AdminUsersResponse = {
  data: AdminUserRow[];
  count: number;
  page: number;
  totalPages: number;
};

export async function getAdminUsers(params: { page?: number; limit?: number; search?: string } = {}): Promise<AdminUsersResponse> {
  const page = params.page ?? 1;
  const limit = params.limit ?? 10;
  const qs = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (params.search) {
    qs.append("search", params.search);
  }
  return apiFetch<AdminUsersResponse>(`/auth/user?${qs.toString()}`, { method: "GET" });
}

export type AdminUsersCountResponse = { count: number };

export async function getAdminUsersCount(): Promise<AdminUsersCountResponse> {
  return apiFetch<AdminUsersCountResponse>(`/auth/user/count`, { method: "GET" });
}

export type UserOption = { id: number; label: string };

export async function getTeachers(): Promise<UserOption[]> {
  const pageSize = 100;
  const first = await getAdminUsers({ page: 1, limit: pageSize });
  const pages = Math.max(1, first.totalPages || 1);
  let all = [...(first.data ?? [])];

  for (let p = 2; p <= pages; p += 1) {
    const next = await getAdminUsers({ page: p, limit: pageSize });
    all = all.concat(next.data ?? []);
  }

  return all
    .filter((u) => u.role === "TEACHER")
    .map((u) => ({
      id: u.id,
      label: `${u.profile?.firstName ?? ""} ${u.profile?.lastName ?? ""}`.trim() || u.email,
    }));
}
